import { render, staticRenderFns } from "./SelectedOption.vue?vue&type=template&id=77c6af2d"
import script from "./SelectedOption.vue?vue&type=script&lang=js"
export * from "./SelectedOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports